module.exports = __webpack_public_path__ + "static/img/333_TO8_2562_og.125d332.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/333_TO8_2562_og.jpg
// module id = 0mPR
// module chunks = 0